import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const RequireRole = ({ role }) => {
  const { loading, isAuthenticated, userRole } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="text-gray-600 dark:text-gray-300">Checking access…</div>
      </div>
    );
  }
  if (!isAuthenticated || userRole !== role) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }
  return <Outlet />;
};

export default RequireRole;